var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 21C9 21.5523 9.44772 22 10 22H14C14.5523 22 15 21.5523 15 21V18H9V21Z",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.60896 13.0615C4.33513 12.4004 4.15182 11.707 4.06275 11H12L19.9373 11C19.8482 11.707 19.6649 12.4004 19.391 13.0615C18.989 14.0321 18.3997 14.914 17.6569 15.6569C16.914 16.3997 16.0321 16.989 15.0615 17.391C14.0909 17.7931 13.0506 18 12 18C10.9494 18 9.90914 17.7931 8.93853 17.391C7.96793 16.989 7.08601 16.3997 6.34315 15.6569C5.60028 14.914 5.011 14.0321 4.60896 13.0615Z",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 3.59321C9.01111 1.57784 10.2494 1.89133 11.1023 2.30977C11.5981 2.55303 12 3.18668 12 3.73896V10",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.49998C7 6.99998 8 6.99998 8 7.49999V10.5",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 7.5C17 7 16 7 16 7.5V10.5",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSink);
export default __webpack_public_path__ + "static/media/Sink.b13d4a4ddbd57ac14963fd19854f8e7d.svg";
export { ForwardRef as ReactComponent };